import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import RichText from 'legacy-src/utility/RichText';
import { Icon } from 'legacy-packages/ft-cb';
import telemetry from 'legacy-src/utility/telemetry';

import { submittable } from '../shared/status';
import { answers } from '../shared/versions';
import Feedback from '../shared/Feedback';
import './multiple_choice.scss';
import { ALPHABET } from 'legacy-src/utility/utils';

const setTrackingData = (
  assignment_id,
  subject,
  question_id,
  item,
  item_type,
) => {
  const data = {
    assignment_id: Number(assignment_id),
    question_id,
    subject_id: Number(subject),
  };

  return {
    event_type: 'choose_answer',
    item,
    item_type,
    params: { ...data },
  };
};

const Player = (props) => {
  const {
    item: { calculator_section, content, questionNumber, id, type },
    submission,
    feedback,
    tracking,
    params,
  } = props;
  const { print, showAnswers } = props.context;
  const { selection, submitted, attempts = [] } = submission.state;
  const reviewing =
    submitted &&
    !_.isEmpty(feedback) &&
    (feedback.attempt || 0) === attempts.length;
  const mcClasses = cn(
    'multiple_choice',
    { 'multiple_choice--feedback': reviewing },
    { 'multiple_choice--alphabetized': content.alphabetize },
    { 'multiple_choice--print': print },
  );

  const calculatorIcon =
    (calculator_section && (
      <div className="calculator_allowed" title="Calculator allowed">
        <Icon name="calculator" size="1.2em" />
      </div>
    )) ||
    null;

  return (
    <div className="question" data-am-type="questions/multiple_choice">
      {calculatorIcon}
      <div className={mcClasses}>
        {print && questionNumber ? (
          <h2 className="multiple_choice__question_number">
            {questionNumber}.
          </h2>
        ) : null}
        <RichText
          className="multiple_choice__question"
          content={content.question}
        />
        <div className="multiple_choice__answers">
          {(content.answers || []).map((answer, index) => {
            const props = {
              disabled: submitted || showAnswers,
              checked: selection === index,
              tracking,
              params,
              item: id,
              item_type: type,
              onChange() {
                if (selection !== index) {
                  submission.setState({ selection: index });
                  props.tracking.trackEvent(
                    setTrackingData(
                      params.assignmentId,
                      params.subject,
                      index + 1,
                      props.item,
                      props.item_type,
                    ),
                  );
                }
              },
            };
            const labelClasses = cn('answer', {
              'answer--checked': props.checked,
              'answer--correct': props.correct,
              'answer--show_correct': showAnswers && answer['@correct'],
            });
            return (
              <label key={index} className={labelClasses}>
                <input type="radio" {...props} />
                {content.alphabetize && (
                  <span className="alpha_radio">{ALPHABET[index]}</span>
                )}

                {/* Show correct answer icon while reviewing */}
                {reviewing && props.checked ? (
                  <Icon name={props.correct ? 'check' : 'x'} size="0.9em" />
                ) : (
                  ''
                )}
                {/* Show correct answer icon for printing purposes */}
                {showAnswers && answer['@correct'] ? (
                  <Icon name="check" size="1.2em" />
                ) : (
                  ''
                )}

                <RichText content={answer.description} />
              </label>
            );
          })}
        </div>
      </div>
      {reviewing && <Feedback {...this.props} />}
    </div>
  );
};

Player.displayName = 'MultipleChoice';

export default {
  Player: telemetry({})(Player),
  status: submittable,
  version: answers,
};
